const KnobLayout = [
    {
        cc: 40,
        sendable: true,
        name: "octave",
        size: "medium",
        top: "32.60%",
        left: "4.20%",
        width: "6.66%",
        height: "11.11%"
    },
    {
        name: "peak",
        size: "medium",
        top: "32.60%",
        left: "14.8%",
        width: "6.66%",
        height: "11.11%"
    },
    {
        name: "cutoff",
        size: "large",
        top: "29.6%",
        left: "26.01%",
        width: "10.66%",
        height: "17.77%"
    },
    {
        cc: 41,
        sendable: true,
        name: "rate",
        size: "medium",
        top: "32.60%",
        left: "40.7%",
        width: "6.66%",
        height: "11.11%"        
    },
    {
        cc: 42,
        sendable: true,
        name: "int",
        size: "medium",
        top: "32.60%",
        left: "51.6%",
        width: "6.66%",
        height: "11.11%"        
    },
    {
        cc: 43,
        sendable: true,
        name: "pitch1",
        size: "small",
        top: "35.7%",
        left: "62.85%",
        width: "3.46%",
        height: "5.77%"        
    },
    {
        cc: 44,
        sendable: true,
        name: "pitch2",
        size: "small",
        top: "35.7%",
        left: "72%",
        width: "3.46%",
        height: "5.77%"        
    },
    {
        cc: 45,
        sendable: true,
        name: "pitch3",
        size: "small",
        top: "35.7%",
        left: "81%",
        width: "3.46%",
        height: "5.77%"        
    },
    {
        name: "volume",
        size: "medium",
        top: "32.60%",
        left: "89.1%",
        width: "6.66%",
        height: "11.11%"        
    },
    {
        name: "tempo",
        size: "small",
        top: "12.2%",
        left: "25.49%",
        width: "3.46%",
        height: "5.77%"        
    },
    {   
        cc: 46,
        sendable: true,
        name: "attack",
        size: "small",
        top: "12.2%",
        left: "34.6%",
        width: "3.46%",
        height: "5.77%"          
    },
    {
        cc: 47,
        sendable: true,
        name: "decay",
        size: "small",
        top: "12.2%",
        left: "43.8%",
        width: "3.46%",
        height: "5.77%"           
    },
    {
        cc: 48,
        sendable: true,
        name: "egInt",
        size: "small",
        top: "12.2%",
        left: "52.9%",
        width: "3.46%",
        height: "5.77%"           
    }
]

export default KnobLayout;